export default __webpack_public_path__ + "static/sun-dc6e382e90effaec8c8c42edc0142399.svg";